import _typeof from '@babel/runtime/helpers/typeof';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import * as React from 'react';
import styled from 'styled-components';
import { spacing2x } from '../../styles/spacing.js';
import { getAdornment } from '../../utils/adornment.js';
import { Tooltip } from '../Tooltip/Tooltip.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var _excluded = ["children", "startAdornment", "tooltipProps"];
var CardTitleAnchor = styled.a.withConfig({
  displayName: "CardTitle__CardTitleAnchor",
  componentId: "sc-112l9gr-0"
})(["&&{-webkit-box-orient:vertical;-webkit-line-clamp:1;color:", ";cursor:pointer;display:-webkit-box;font-weight:bold;line-height:20px;overflow:hidden;position:relative;text-overflow:ellipsis;white-space:normal;word-break:break-all;}&&:hover,&&:focus{color:", ";}"], function (props) {
  return props.theme.neutralColors.charcoal;
}, function (props) {
  return props.theme.neutralColors.charcoal;
});
var CardTitleAdornment = styled.div.withConfig({
  displayName: "CardTitle__CardTitleAdornment",
  componentId: "sc-112l9gr-1"
})(["&&{display:inline-flex;line-height:0;height:20px;padding-inline-end:", ";vertical-align:top;}"], spacing2x);
var CardTitleAdornmentPositioner = styled.div.withConfig({
  displayName: "CardTitle__CardTitleAdornmentPositioner",
  componentId: "sc-112l9gr-2"
})(["&&{align-items:center;display:flex;flex:1;}"]);
var CardTitle = /*#__PURE__*/React.forwardRef(function CardTitle2(props, ref) {
  var children = props.children,
      startAdornment = props.startAdornment,
      tooltipProps = props.tooltipProps,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/jsx(Tooltip, _objectSpread(_objectSpread({
    content: children
  }, tooltipProps), {}, {
    children: /*#__PURE__*/jsxs(CardTitleAnchor, _objectSpread(_objectSpread({}, rest), {}, {
      ref: ref,
      children: [startAdornment && /*#__PURE__*/jsx(CardTitleAdornment, {
        children: /*#__PURE__*/jsx(CardTitleAdornmentPositioner, {
          children: getAdornment(startAdornment, {
            iconSize: 24
          })
        })
      }), children]
    }))
  }));
});
CardTitle.propTypes = {
  "children": _PropTypes.string.isRequired,
  "startAdornment": function checkAdornment(props, propName, componentName) {
    var isReactNodeType = function isReactNodeType(el) {
      var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for ? Symbol.for('react.element') : 0xeac7;
      var isValidElement = _typeof(el) === 'object' && el !== null && el['\$\$typeof'] === REACT_ELEMENT_TYPE;
      return el === undefined || el === null || typeof el === 'boolean' || typeof el === 'string' || isValidElement;
    };

    var adornment = (propName === 'startAdornment' || propName === 'endAdornment') && props[propName];

    if (!isReactNodeType(adornment)) {
      var name = adornment.displayName || adornment.name || 'Component';

      if (!(name.indexOf('Icon') === 0)) {
        return new Error("Invalid prop \"".concat(propName, "\". Invalid React component with name \"").concat(name, "\" was supplied to \"").concat(componentName, "\". Only Icon components are allowed.\n"));
      }
    }
  },
  "tooltipProps": _PropTypes.object
};
CardTitle.displayName = "CardTitle";

export { CardTitle };
